import React from "react";
import {
    Wrapper,
    WorkOrderStatusWrapper
} from "./styled";
import { ReactComponent as StartArrow } from "assets/svgs/status-arrow-start.svg";
import { ReactComponent as Arrow } from "assets/svgs/status-arrow.svg";


export const WorkOrderStatusBar = ({ status }) => {
    return <Wrapper>
        <WorkOrderStatusWrapper data-active={status === 'open'}>
            <StartArrow/>
            <span>Open</span>
        </WorkOrderStatusWrapper>

        <WorkOrderStatusWrapper data-active={status === 'onHold'}>
            <Arrow/>
            <span>On Hold</span>
        </WorkOrderStatusWrapper>

        <WorkOrderStatusWrapper data-active={status === 'inProgress'}>
            <Arrow/>
            <span>In Progress</span>
        </WorkOrderStatusWrapper>

        <WorkOrderStatusWrapper data-active={status === 'complete'}>
            <Arrow/>
            <span>Closed</span>
        </WorkOrderStatusWrapper>
    </Wrapper>
};

export default WorkOrderStatusBar;
